import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ICON_PLACEHOLDER_PATH_SHARP = ___EmotionJSX(React.Fragment, null, ___EmotionJSX("path", {
  d: "M3 3H6V4H4V6H3V3Z"
}), ___EmotionJSX("path", {
  d: "M18 3H21V6H20V4H18V3Z"
}), ___EmotionJSX("path", {
  d: "M4 18V20H6V21H3V18H4Z"
}), ___EmotionJSX("path", {
  d: "M21 18V21H18V20H20V18H21Z"
}), ___EmotionJSX("path", {
  d: "M10 4H7V3H10V4Z"
}), ___EmotionJSX("path", {
  d: "M13 4H11V3H13V4Z"
}), ___EmotionJSX("path", {
  d: "M17 4V3H14V4H17Z"
}), ___EmotionJSX("path", {
  d: "M17 21V20H14V21H17Z"
}), ___EmotionJSX("path", {
  d: "M13 21V20H11V21H13Z"
}), ___EmotionJSX("path", {
  d: "M10 21V20H7V21H10Z"
}), ___EmotionJSX("path", {
  d: "M4 7H3V10H4V7Z"
}), ___EmotionJSX("path", {
  d: "M21 7V10H20V7H21Z"
}), ___EmotionJSX("path", {
  d: "M4 11H3V13H4V11Z"
}), ___EmotionJSX("path", {
  d: "M21 11V13H20V11H21Z"
}), ___EmotionJSX("path", {
  d: "M4 14H3V17H4V14Z"
}), ___EmotionJSX("path", {
  d: "M21 14V17H20V14H21Z"
}), ___EmotionJSX("path", {
  d: "M19 5H18.9596L19 5.04044V5Z"
}), ___EmotionJSX("path", {
  d: "M5 5V5.04052L5.04052 5H5Z"
}), ___EmotionJSX("path", {
  d: "M5 19H5.04044L5 18.9596V19Z"
}), ___EmotionJSX("path", {
  d: "M19 19V18.9596L18.9596 19H19Z"
}), ___EmotionJSX("path", {
  d: "M18 5.29293L18.7071 6.00004L16.6667 8.04048L15.9596 7.33337L18 5.29293Z"
}), ___EmotionJSX("path", {
  d: "M15.3334 7.9596L16.0405 8.6667L14 10.7071L13.2929 10L15.3334 7.9596Z"
}), ___EmotionJSX("path", {
  d: "M12.6667 10.6263L13.3738 11.3334L12.7071 12L13.3738 12.6667L12.6667 13.3738L12 12.7071L11.3334 13.3738L10.6263 12.6667L11.2929 12L10.6263 11.3334L11.3334 10.6263L12 11.2929L12.6667 10.6263Z"
}), ___EmotionJSX("path", {
  d: "M10 13.2929L10.7071 14L8.66671 16.0405L7.9596 15.3334L10 13.2929Z"
}), ___EmotionJSX("path", {
  d: "M7.33337 15.9596L8.04048 16.6667L6.00004 18.7071L5.29293 18L7.33337 15.9596Z"
}), ___EmotionJSX("path", {
  d: "M6.00004 5.29293L5.29293 6.00004L7.33337 8.04048L8.04048 7.33337L6.00004 5.29293Z"
}), ___EmotionJSX("path", {
  d: "M8.6667 7.9596L7.9596 8.6667L10 10.7071L10.7071 10L8.6667 7.9596Z"
}), ___EmotionJSX("path", {
  d: "M14 13.2929L13.2929 14L15.3334 16.0405L16.0405 15.3334L14 13.2929Z"
}), ___EmotionJSX("path", {
  d: "M16.6667 15.9596L15.9596 16.6667L18 18.7071L18.7071 18L16.6667 15.9596Z"
}));
export default ICON_PLACEHOLDER_PATH_SHARP;